// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.preprod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyB_gteKiDdJKB2dGZLD0X1GXEvZWa9XZXA',
    authDomain: 'paisa-mf.firebaseapp.com',
    databaseURL: 'https://paisa-mf.firebaseio.com',
    projectId: 'paisa-mf',
    storageBucket: 'paisa-mf.appspot.com',
    messagingSenderId: '945111842441',
    appId: '1:945111842441:web:62b18ca398857c472b5058',
    measurementId: 'G-FW30J08J2Z',
  },
  kycApiUrl: 'https://kyc-pre.5paisa.com/',
  keys: {
    aesKeyEncrypted: '842a357c4b385726090aa184b75b691075da95e6ddd4eb40',
    aesIVEncrypted: '53471a3a3623160b53471a3a3623160b',
  },

  // Gateway Base URLs (Pre-Production)
  authBaseAPI: 'https://gateway.5paisa.com/AuthApi/',
  pwaSpotbaseAPI: 'https://gateway.5paisa.com/pwaspot/',
  boApi: 'https://gateway.5paisa.com/BoAPI/Common/',
  logApiUrl: 'https://uatapi.5paisa.in/brokingcommonapi/api/login/v1/',
  tradeApiUrl: 'https://gateway.5paisa.com/tradeapi/',

  // Platform URLs
  tradestationUrl: 'https://web.5paisa.com/',
  tradestationNewUrl: 'https://newweb.5paisa.com/',
  fnoUrl: 'https://fno.5paisa.com/',
  chartUrl: 'https://tv.5paisa.com',

  // Activation & Modification URLs
  activationUrl: 'https://gateway.5paisa.com/5peaccount/',
  activationModificationUrl: 'https://diygateway.5paisa.com/5peaccount/',
  modificationUrl: 'https://diygateway.5paisa.com/emodify/',
  pwaUrl: 'https://pwaweb.5paisa.com/#/activation',
  pwaNewUrl: 'https://kyc.5paisa.com/activation-new',

  // Account & Authentication URLs
  accountPending:
    'https://eaccount.5paisa.com/ClientLogin/VerifyClientLoginMobile',
  // swarajAuthUrl:
  //   'https://preapigateway.5paisa.com/trading/swarajauth/AuthenticateService/Service1.svc',
  swarajAuthUrl:
    'https://apigateway.5paisa.com/trading/swarajauth/AuthenticateService/Service1.svc',
  getContentApiUrl:
    'https://swarajauth.5paisa.com/AuthenticateService/Service1.svc/GetContent',
  pwauatCookieApiUrl: 'https://pwauatapi.5paisa.com/',

  // Miscellaneous URLs
  termsAndConditionUrl: 'https://www.5paisa.com/terms-and-conditions',
  OptoutUrl:
    'https://emodify.5paisa.com/customer-dashboard/client-profile?source=nominee_declaration&appsource=App&nomtype=opt_in',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
